import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import classNames from "classnames";
// i18n
import { withNamespaces } from "react-i18next";
// Ducks
import { fetchAppFeatureSettings } from "../../../../../../services/clientSettings.ducks";
import { clearSelectedCandidate } from "../../../../UsersList/UsersList.ducks";
import { navigateTo } from "../../../../Dashboard.ducks";
import { logout, USERNAME_KEY } from "../../../../../../services/auth.ducks";
// Constants
import { ADMIN } from "../../../../../../config/constants";
// Styles
import styles from "./UserMenu.css";
import "./styles.css";
// Components
import MenuItem from "./components/MenuItem";

class UserMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasActiveVoucherSystem: true,
      hasActivePayment: false,
      open: false
    };
    this.node = React.createRef();
  }

  async componentDidMount() {
    document.addEventListener(`mousedown`, this.handleClick, false);
    document.addEventListener(`touchstart`, this.handleClick, false);

    const { fetchAppFeatureSettings } = this.props;
    const appFeatureSettings = await fetchAppFeatureSettings();

    this.setState({
      hasActiveVoucherSystem: appFeatureSettings.hasActiveVoucherSystem,
      hasActivePayment: appFeatureSettings.hasActivePayment
    });

  }

  componentWillUnmount() {
    document.removeEventListener(`mousedown`, this.handleClick, false);
    document.removeEventListener(`touchstart`, this.handleClick, false);
  }

  handleBlur = () => {
    this.setState({ open: false });
  };

  handleClick = (e) => {
    if (this.node.contains(e.target)) {
      return;
    }

    this.handleBlur();
  };

  handleMenuItemClick = (action) => (e) => {
    e.stopPropagation();
    const { clearSelectedCandidate, logout, navigateTo, role } = this.props;

    switch (action) {
      case `dashboard`:
        if (role === ADMIN) {
          clearSelectedCandidate();
          navigateTo(`/dashboard/users`);
        } else {
          navigateTo(`/dashboard`);
        }
        break;
      case `bookings`:
        navigateTo(`/dashboard/bookings`);
        break;
      case `paymenthistory`:
        navigateTo(`/dashboard/paymenthistory`);
        break;
      case `vouchers`:
        navigateTo(`/dashboard/vouchers`);
        break;
      case `settings`:
        navigateTo(`/dashboard/settings`);
        break;
      case `logout`:
        logout();
        break;

      default:
        break;
    }

    return this.toggleDropdown();
  };

  toggleDropdown = (e) => {
    e && e.stopPropagation();

    this.setState((prevState) => ({ open: !prevState.open }));
  };

  render() {
    const { role, t, isUserActive } = this.props;
    const { open, hasActiveVoucherSystem, hasActivePayment } = this.state;
    const usernameKey = localStorage.getItem(USERNAME_KEY);
    const isCandidate = role !== ADMIN;
    const nameString = isCandidate ? usernameKey : `${t(`modules.localization.register.authenticated.userMenu.administrator`)} (${usernameKey})`;
    const hidePaymentHistory = !isCandidate || (isCandidate && !hasActivePayment);

    return (
      <div
        className={classNames(`btn-group dropdown pull-right`, {
          open
        })}
        // eslint-disable-next-line no-return-assign
        ref={(node) => (this.node = node)}
        style={styles.container}
      >
        <button
          className="btn btn-link dropdown-toggle"
          onClick={this.toggleDropdown}
          style={styles.button}
          type="button"
        >
          <div className="user-menu-name" style={styles.textWrapper}>
            {`${nameString} `}
          </div>
          <i className="fa fa-cog" style={styles.cogIcon} />
        </button>
        {open && (
          <ul className="dropdown-menu">
            <MenuItem hidden={!isUserActive} onClick={this.handleMenuItemClick(`dashboard`)}>
              {t(`modules.localization.register.authenticated.userMenu.bookNow`)}
            </MenuItem>
            <MenuItem hidden={!isCandidate} onClick={this.handleMenuItemClick(`bookings`)}>
              {t(`modules.localization.register.authenticated.userMenu.bookings`)}
            </MenuItem>
            <MenuItem hidden={hidePaymentHistory} onClick={this.handleMenuItemClick(`paymenthistory`)}>
              {t(`modules.localization.register.authenticated.userMenu.payments`)}
            </MenuItem>
            <MenuItem onClick={this.handleMenuItemClick(`vouchers`)} hidden={(isCandidate && !isUserActive) || !hasActiveVoucherSystem}>
              {t(`modules.localization.register.authenticated.userMenu.vouchers`)}
            </MenuItem>
            <MenuItem hidden={!isCandidate || !isUserActive} onClick={this.handleMenuItemClick(`settings`)}>
              {t(`modules.localization.register.authenticated.userMenu.settings`)}
            </MenuItem>
            <MenuItem onClick={this.handleMenuItemClick(`logout`)}>
              {t(`modules.localization.register.authenticated.userMenu.logOut`)}
            </MenuItem>
          </ul>
        )}
      </div>
    );
  }
}

UserMenu.propTypes = {
  clearSelectedCandidate: PropTypes.func.isRequired,
  fetchAppFeatureSettings: PropTypes.func.isRequired,
  isUserActive: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  navigateTo: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  role: state.auth.role,
  isUserActive: state.auth.profile.isUserActive
});

const mapDispatchToProps = {
  clearSelectedCandidate,
  fetchAppFeatureSettings,
  logout,
  navigateTo
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(UserMenu);
